import { Embroidery } from 'src/types'
import {
  notThumbEmbroidery,
  liningEmbroidery,
  thumbEmbroidery,
  bottomRightOfBeltEmbroidery,
  sideOfLabelEmbroidery,
  thumbEmbroideryLeftThrow,
  thumbEmbroideryUs,
  notThumbEmbroideryWithEmoji,
  liningEmbroideryWithEmoji
  // circleHollowOutEmbroidery
} from 'src/features/brands/atoms/canvas/common/back/embroidery'

const liningEmbroideryObject = {
  first: {
    x: 115,
    y: -75,
    position: 'leatherLiningFirst'
  },
  second: {
    x: 120,
    y: -30,
    position: 'leatherLiningSecond'
  }
}

export const liningEmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  embroideries: Embroidery[],
  step: 'first' | 'second',
  fontSize?: string
): void => {
  const isEmbroideryOfLining = embroideries?.some((x) => x.position.value === liningEmbroideryObject[step].position)
  if (isEmbroideryOfLining) {
    liningEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === liningEmbroideryObject[step].position),
      liningEmbroideryObject[step].x,
      liningEmbroideryObject[step].y,
      fontSize
    )
  }
}
export const liningEmbroideryUsDrawer = (
  ctx: CanvasRenderingContext2D,
  embroideries: Embroidery[],
  step: 'first' | 'second',
  fontSize?: string
): void => {
  const isEmbroideryOfLining = embroideries?.some((x) => x.position.value === liningEmbroideryObject[step].position)
  if (isEmbroideryOfLining) {
    liningEmbroideryWithEmoji(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === liningEmbroideryObject[step].position),
      liningEmbroideryObject[step].x,
      liningEmbroideryObject[step].y,
      fontSize
    )
  }
}

export const thumbEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[]): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryDraw)
    thumbEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'thumbFinger'),
      -85,
      38,
      -15
    )
}

export const thumbEmbroideryDrawerForUsAtoms = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[]): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryDraw)
    thumbEmbroideryUs(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'thumbFinger'),
      -200,
      38,
      -15
    )
}

export const thumbEmbroideryDrawerForUsAtomsLeftThrow = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[]): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryDraw)
    thumbEmbroideryLeftThrow(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === 'thumbFinger'),
      70,
      110,
      -10
    )
}

const nonThumbEmbroideryObject = {
  middleFinger: {
    x: -140,
    y: -190,
    numerator: 5
  },
  ringFinger: {
    x: -60,
    y: -80,
    numerator: -5
  },
  childFinger: {
    x: -70,
    y: -45,
    numerator: -2
  }
}

export const nonThumbEmbroideryDrawer = (
  ctx: CanvasRenderingContext2D,
  fingerType: 'middleFinger' | 'ringFinger' | 'childFinger',
  embroideries: Embroidery[]
): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === fingerType)
  if (isEmbroideryDraw) {
    notThumbEmbroidery(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === fingerType),
      nonThumbEmbroideryObject[fingerType].x,
      nonThumbEmbroideryObject[fingerType].y,
      nonThumbEmbroideryObject[fingerType].numerator
    )
  }
}
export const nonThumbEmbroideryUsDrawer = (
  ctx: CanvasRenderingContext2D,
  fingerType: 'middleFinger' | 'ringFinger' | 'childFinger',
  embroideries: Embroidery[]
): void => {
  const isEmbroideryDraw = embroideries?.some((x) => x.position.value === fingerType)
  if (isEmbroideryDraw) {
    notThumbEmbroideryWithEmoji(
      ctx,
      embroideries.find((embroidery) => embroidery.position.value === fingerType),
      nonThumbEmbroideryObject[fingerType].x,
      nonThumbEmbroideryObject[fingerType].y,
      nonThumbEmbroideryObject[fingerType].numerator
    )
  }
}

export const bottomRightOfBeltEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[], x: number, y: number): void => {
  const filterFunction = (x: Embroidery) => x.position.value === 'belt'
  const isEmbroideryOfLining = embroideries?.some(filterFunction)
  if (isEmbroideryOfLining) {
    bottomRightOfBeltEmbroidery(ctx, embroideries?.find(filterFunction), x, y)
  }
}

export const sideOfLabelEmbroideryDrawer = (ctx: CanvasRenderingContext2D, embroideries: Embroidery[], x: number, y: number): void => {
  const filterFunction = (x: Embroidery) => x.position.value === 'sideOfLabel'
  const isEmbroideryOfLining = embroideries?.some(filterFunction)
  if (isEmbroideryOfLining) {
    sideOfLabelEmbroidery(ctx, embroideries?.find(filterFunction), x, y)
  }
}

// export const circleHollowOutEmbroideryDrawer = (
//   ctx: CanvasRenderingContext2D,
//   embroideries: Embroidery[]
// ) => {
//   const filterFunction = (x: Embroidery) => x.position.value === 'circleHollowOut'
//   const isEmbroideryOfCircleHollowOut = embroideries.some(filterFunction)
//   if (isEmbroideryOfCircleHollowOut) {
//     circleHollowOutEmbroidery(ctx, embroideries.find(filterFunction), 0, 0)
//   }
// }

// eslint-disable-next-line
export const isHalfWidthCharChecker = (str: string) => !str.match(/^[^\x01-\x7E\xA1-\xDF]+$/)
